import { defineStore } from 'pinia'
import { ref } from 'vue'
import { api } from '@/plugins/api'

export const useEstablishmentStore = defineStore('establishement', () => {
    const establishments = ref([])

    async function fetchAllAvailableEstablishments() {
        const response = await api.establishment.getAllAvailableEstablishments()
        establishments.value = response.data
    }

    return { establishments, fetchAllAvailableEstablishments }
})
